import React from "react";
import SubPicture from "components/comp/SubPicture";
import ArchiImg from "assets/images/cloud-saas-architecture.png";
import SaaSOverview from "components/comp/SaaSOverview";
import SaaSArchitecture from "components/comp/SaaSArchitecture";
import SaaSOperation from "components/comp/SaaSOperation";
import SaaSSecurity from "components/comp/SaaSSecurity";
import SaaSProcess from "components/comp/SaaSProcess";
import SaaSBenefits from "components/comp/SaaSBenefits";
import SaaSCallout from "components/comp/SaaSCallout";

const CompHyGateOne = () => {
  return (
    <main className="page-sub">
      <section className="company-main">
        <SubPicture img={ArchiImg} />
        <SaaSOverview />
        <SaaSArchitecture />
        <SaaSOperation />
        <SaaSSecurity />
        <SaaSProcess />
        <SaaSBenefits />
        <SaaSCallout />
      </section>
    </main>
  );
};

export default CompHyGateOne;
